<template>
	<div>
		<v-content>
			<v-btn flat icon class="hidden-xs-only" @click="back">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-flex xs12 sm6 offset-sm3>
				<v-card>
					<v-card-title>
						<h3 class="mb-0">{{textinfo.title1}}</h3>
					</v-card-title>
					<v-card-text>
						<v-layout justify-space-between row>
							<v-flex sm4>
								{{textinfo.organizationName}}
							</v-flex>
							<v-flex sm8 v-if="isLanguageEn()"><b>{{content.englishName}}</b></v-flex>
							<v-flex sm8 v-else><b>{{content.polishName}}</b></v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
				<v-card>
					<v-card-title>
						<h3 class="mb-0">{{textinfo.title2}}</h3>
					</v-card-title>
					<v-card-text>
						<v-layout row>
							<v-flex sm4>
								{{textinfo.phoneNumber}}
							</v-flex>
							<v-flex sm8><b>
								{{content.phoneNumber}}
							</b></v-flex>
						</v-layout>
						<v-layout row>
							<v-flex sm4>
								{{textinfo.email}}
							</v-flex>
							<v-flex sm8><b>
								{{content.email}}
							</b></v-flex>
						</v-layout>
						<v-layout row>
							<v-flex sm4>
								{{textinfo.www}}
							</v-flex>
							<v-flex sm8><b>
								{{content.www}}
							</b></v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
				<v-card>
					<v-card-title>
						<h3 class="mb-0">{{textinfo.title4}}</h3>
					</v-card-title>
					<v-card-text>
						<div v-if="content.activityCountries.length > 0 && !isLanguageEn()">
							<div v-for="item in content.activityCountries" v-bind:key="item.id">
								<v-layout row style="margin-left: 20px">
									<b>{{item.name}}</b>
								</v-layout>
							</div>
						</div>
						<div v-else-if="content.activityCountries.length > 0 && isLanguageEn()">
							<div v-for="item in content.activityCountries" v-bind:key="item.id">
								<v-layout row style="margin-left: 20px">
									<b>{{item.englishName}}</b>
								</v-layout>
							</div>
						</div>
						<v-layout row v-else>
							<b>-</b>
						</v-layout>
					</v-card-text>
				</v-card>
				<v-card>
					<v-card-title>
						<h3 class="mb-0">{{textinfo.title5}}</h3>
					</v-card-title>
					<v-card-text>
						<div v-if="content.activityTypes.length > 0 && !isLanguageEn()">
							<div v-for="item in content.activityTypes" v-bind:key="item.id">
								<v-layout row style="margin-left: 20px">
									<b>{{item.name}}</b>
								</v-layout>
							</div>
						</div>
						<div v-else-if="content.activityTypes.length > 0 && isLanguageEn()">
							<div v-for="item in content.activityTypes" v-bind:key="item.id">
								<v-layout row style="margin-left: 20px">
									<b>{{item.englishName}}</b>
								</v-layout>
							</div>
						</div>
						<v-layout row v-else>
							<b>-</b>
						</v-layout>
					</v-card-text>
				</v-card>
				<v-card>
					<v-card-title>
						<h3 class="mb-0">{{textinfo.title6}}</h3>
					</v-card-title>
					<v-card-text>
						<div style="white-space: pre-wrap" v-if="isLanguageEn()">{{content.englishDescription}}</div>
						<div style="white-space: pre-wrap" v-else>{{content.polishDescription}}</div>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex><br></v-flex>
		</v-content>
	</div>
</template>

<script>
	import {Api} from "@/api";

	export default {
		name: "BidderDetailsView",

		computed: {
			textinfo() {
				if (this.isLanguageEn()) return this.englishTextInfo;
				else return this.polishTextInfo;
			},
		},

		methods: {
			back() {
				this.$router.go(-1);
			},
			isLanguageEn() {
				return localStorage.getItem("language") !== "PL";
			},
		},

		beforeCreate() {
			Api.get(this, "/bidder/details?id=" + this.$route.params.id, response => {
				this.content = response;
				this.$set(this, 'content', response);
			});
		},

		data() {
			return {
				polishTextInfo: {
					title1: "Fiszka informacyjna",
					organizationName: "Nazwa organizacji:",
					title2: "Dane teleadresowe organizacji",
					city: "Miejscowość:",
					phoneNumber: "Telefon stacjonarny:",
					email: "Adres e-mail:",
					www: "Strona internetowa:",
					title4: "Kraje działania",
					title5: "Rodzaje działalności",
					title6: "Opis",
				},
				englishTextInfo: {
					title1: "Basic information",
					organizationName: "Organization name:",
					title2: "Organization contact details",
					city: "City:",
					phoneNumber: "Phone number:",
					email: "E-mail address:",
					www: "Website:",
					title4: "Activity countries",
					title5: "Activity type",
					title6: "Description",
				},
				content: {
					polishName: "-",
					englishName: "-",
					phoneNumber: "-",
					email: "-",
					www: "-",
					activityCountries: [],
					activityTypes: []
				},
			};
		},
	};

</script>

<style scoped>

</style>
